import type {
  EndpointArgument,
  ParseArgument,
  Provider,
  ProviderOptions,
  ProviderParams,
  SearchArgument,
  SearchResult,
} from 'leaflet-geosearch/dist/providers/provider.js'

// biome-ignore lint/suspicious/noExplicitAny: <auto ignored after biome migration>
export abstract class AbstractProvider<TRequestResult = any, TRawResult = any>
  implements Provider<TRequestResult, TRawResult>
{
  // @ts-expect-error Constructor implementation is missing because it's an abstract class.
  constructor(options?: ProviderOptions)

  abstract getParamString(params?: ProviderParams): string
  abstract getUrl(url: string, params?: ProviderParams): string
  abstract search(options: SearchArgument): Promise<SearchResult<TRawResult>[]>
  abstract endpoint(options: EndpointArgument): string
  abstract parse(
    response: ParseArgument<TRequestResult>,
  ): SearchResult<TRawResult>[]

  options!: ProviderOptions
}
